<template>
  <el-dialog
    :title="title"
    append-to-body
    destroy-on-close
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="600px"
  >
    <div v-loading="loading">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model.trim="form.roleName" placeholder="请输入" clearable/>
        </el-form-item>
        <el-form-item label="角色权限">
          <el-tree
            ref="tree"
            node-key="path"
            show-checkbox
            :data="treeData"
            default-expand-all
            check-on-click-node
            :default-checked-keys="defaultCheckKeys"
            :props="{ children: 'subPermissions', label: 'description' }"
          >
          </el-tree>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loadingSubmit" :disbaled="loadingSubmit" @click="submitForm">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { addrolepermissions as add, updaterolepermissions as update, rolepermissions } from 'api/request'
  export default {
    data () {
      return {
        title: '更新角色权限',
        visible: false,
        loading: false,
        loadingSubmit: false,
        // 表单参数
        form: {
          id: undefined,
          roleName: '',
        },
        // 表单校验
        rules: {
          roleName: [
            {required: true, message: '请输入角色名称', trigger: 'blur'}
          ],
        },
        treeData: [],
        defaultCheckKeys: [],
        toLineTreeData: [],
      }
    },
    watch: {
      visible (val) {
        if (!val) {
          Object.assign(this.$data, this.$options.data.call(this));
        }
      },
    },
    methods: {
      async show(data) {
        const { permissions } = data
        await this.getAllRolepermissions(permissions)
        if (data.id) {
          this.title = '更新角色权限'
          this.form = data
        }
        this.visible = true
      },
      submitForm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let params = {
              roleName: this.form.roleName,
              permissions: this.getCheckedNodes()
            }
            if (this.form.id) {
              params.roleId = this.form.id
            }
            const API = this.form.id ? update : add
            this.loading = true
            this.loadingSubmit = true
            API(params).then((res) => {
              if (res) {
                this.$message({ message: '操作成功', type: 'success' })
                this.$emit('done', this.form.id)
                this.close()
              }
              this.loading = false
              this.loadingSubmit = false
            }).finally(() => {
              this.loading = false
              this.loadingSubmit = false
            })
          }
        })
      },
      async getAllRolepermissions (currentPermissions) {
        this.$nextTick(async () => {
          this.loading = true
          let data = await rolepermissions()
          this.treeData = (data && Array.isArray(data)) ? data : []
          this.toLineTreeData = (data && Array.isArray(data)) ? this.common.toLine(data, 'subPermissions') : []
          if (currentPermissions && this.toLineTreeData.length > 0) {
            let defaultCheckKeys = []
            currentPermissions.forEach(v => {
              this.toLineTreeData.forEach(cV => {
                if (((v === cV.path) && !cV.subPermissions) || (v === cV.path) && cV.subPermissions.length === 0) {
                  defaultCheckKeys.push(v)
                }
              })
            })
            this.defaultCheckKeys = defaultCheckKeys
          }
          this.loading = false
        })
      },
      //获取选中的菜单id  组装成数组
      getCheckedNodes() {
        var rad = '';
        //获取半父节点选择key  this.$refs.tree.getHalfCheckedKeys()
        var ridsa = (this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())).join(',');// 获取当前的选中的数据[数组] -id, 把数组转换成字符串
        //获取半父节点选择对象  this.$refs.tree.getHalfCheckedNodes()
        var ridsb = this.$refs.tree.getCheckedNodes().concat(this.$refs.tree.getHalfCheckedNodes());// 获取当前的选中的数据[{节点对象}]
        ridsb.forEach(ids => {//获取选中的所有的父级id
          rad += ',' + ids.path;
        });
        rad = rad.substr(1);// 删除字符串前面的','
        var rids = rad + ',' + ridsa;
        var arr = rids.split(',');//  把字符串转换成数组
        arr = [...new Set(arr)]; // 数组去重
        if (arr[0] === '') {
          arr = [];
        }
        return arr || [];
      },
      /** 关闭弹窗 */
      close() {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
